import { createFileRoute } from "@tanstack/react-router";

import { ContactPage } from "@/components/marketing/contact-page";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/(public)/contact")({
  head: () => pageHead("contact"),
  component: ContactPage,
});
